<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>商品</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/exam/list' }">我的题库</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/exam/bugreport' }">题库报错</el-breadcrumb-item>
        <el-breadcrumb-item>报错详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">报错详情</h2>
        </div>
        <div class="right">
        </div>
      </div>
    </div>
    <div
      class="card"
      style="margin-top:10px;"
    >
      <div class="info">
        题库名称：{{dataForm.exam?dataForm.exam.name:""}} &nbsp;&nbsp;|&nbsp;&nbsp;
        章节名称：{{dataForm.chapter?dataForm.chapter.name:""}} &nbsp;&nbsp;|&nbsp;&nbsp;
        题目章节：{{dataForm.child_chapter?dataForm.child_chapter.name:""}} &nbsp;&nbsp;|&nbsp;&nbsp;
        题号：{{dataForm.item?dataForm.item.sort:""}}&nbsp;&nbsp;|&nbsp;&nbsp;
        错误类型：{{formateBug_type(dataForm.bug_type)}}
      </div>
    </div>
    <div
      class="card"
      style="margin-top:10px;"
    >
      <div class="header-title">
        基本信息
        <el-button
          class="button"
          type="primary"
          v-if="dataForm.modify_status==1"
          @click="changeStatus(0,'确定要变更为未处理吗')"
        >已处理</el-button>
        <el-button
          class="button"
          type="danger"
          @click="changeStatus(1,'确定要变更为已处理吗')"
          v-if="dataForm.modify_status==0"
        >未处理</el-button>
      </div>
      <div class="info-item">
        <div class="title">本题错误详情和建议：</div>
        <div class="value">
          <div class="detail-content">
            {{dataForm.detail}}
          </div>
        </div>
      </div>
      <div
        class="info-item"
        v-if="dataForm.picture_url"
      >
        <div class="title">图片：</div>
        <div class="value">
          <div class="img-content">
            <el-image
              style="max-height:200px;height:200px;margin-right:16px;"
              v-for="(item,index) in dataForm.picture_url.split(',')"
              :key="index"
              :src="item"
              @click="openViewer(item)"
            ></el-image>
          </div>
        </div>
      </div>
      <div
        class="info-item"
        v-if="dataForm.exam_item"
      >
        <div class="title">题目详情：</div>
        <div class="value">
          <Single
            v-if="dataForm.exam_item.answer_type === 0"
            title="单选题"
            :content="item_subject"
          ></Single>
          <Multiple
            v-if="dataForm.exam_item.answer_type === 1"
            title="多选题"
            :content="item_subject"
          ></Multiple>
          <Judge
            v-if="dataForm.exam_item.answer_type === 3"
            title="判断题"
            :content="item_subject"
          ></Judge>
          <Qa
            v-if="dataForm.exam_item.answer_type === 4"
            title="自测题"
            :content="item_subject"
          ></Qa>
          <Material
            v-if="dataForm.exam_item.answer_type === 8"
            title="材料题"
            :content="item_subject"
          ></Material>
        </div>
      </div>
      <!--       <div class="footer">
        <el-button
          class="button"
          type="primary"
          @click="submit()"
        >保存</el-button>
      </div> -->
    </div>
    <el-image-viewer
      v-if="showViewer"
      :url-list="tableImg"
      :on-close="closeViewer"
    />
  </div>
</template>

<script>
import {
  examBugReportOne,
  examBugReportpdate
} from "@/api/exam";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import Single from "@/components/exam/Single";
import Multiple from "@/components/exam/Multiple";
import Judge from "@/components/exam/Judge";
import Qa from "@/components/exam/Qa";
import Material from "@/components/exam/Material";

export default {
  components: {
    Single,
    Multiple,
    Judge,
    Qa,
    Material,
    ElImageViewer
  },
  data() {
    return {
      dataForm: {},
      filters: {
        bug_type: [
          { label: "题干内容错误", value: "0" },
          { label: "内容选项错误", value: "1" },
          { label: "正确答案不匹配", value: "2" },
          { label: "题目错误解析", value: "3" },
          { label: "错别字", value: "4" },
        ],
      },
      tableImg: [],
      showViewer: false,
      item_subject: null,
    };
  },
  filters: {

  },
  watch: {

  },
  created() {
    this.fetchDetail()
  },
  mounted() {

  },
  methods: {
    fetchDetail() {
      examBugReportOne({ id: this.$route.params.id }).then((res) => {
        if (res) {
          this.dataForm = res
          this.item_subject = Object.assign({}, res.exam_item, {
            item_id: res.exam_item.id
          })
          if (this.item_subject.options) {
            this.item_subject.options.forEach((v) => {
              v.true_option = v.true_option === 1 ? true : false;
            });
          }
          if (this.item_subject.children) {
            this.item_subject.children.forEach((subItem) => {
              if (subItem.options) {
                subItem.options.forEach((v) => {
                  v.true_option = v.true_option === 1 ? true : false;
                });
              }
            });
          }
        }
      });
    },
    formateBug_type(value) {
      if (value) {
        let val = value.split(',').map(v => { return this.filters.bug_type.find(t => { return v == t.value }).label })
        return val.join('，')
      } else {
        return '无'
      }
    },
    openViewer(url) {
      this.tableImg = [url];
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    submit(status) {
      let query = {
        id: this.dataForm.id,
        modify_status: status,
      }
      examBugReportpdate(query).then((res) => {
        if (res) {
          this.fetchDetail()
        }
      });
    },
    changeStatus(status, text) {
      this.$confirm(text, "提示", {
        type: "warning",
      })
        .then(() => {
          this.submit(status)
        })
        .catch(() => { });
    }
  },
};
</script>

<style lang="less" scoped>
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
    .info-item {
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      .title {
        font-weight: 400;
        color: #707070;
        margin-bottom: 16px;
      }
      .value {
        .detail-content {
          background: #f5f5f5;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          padding: 16px;
          font-size: 12px;
          font-weight: 400;
          color: #707070;
          line-height: 22px;
        }
        .img-content {
        }
      }
    }
  }
  .info {
    font-size: 14px;
    font-weight: 400;
    color: #707070;
    line-height: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }
  .header-title {
    padding-bottom: 16px;
    border-bottom: dashed 1px #cccccc;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .footer {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>